import {
    FETCH_ASSIGNED_CARD_ACCOUNTS_REQUEST,
    FETCH_ASSIGNED_CARD_ACCOUNTS_SUCCESS,
    FETCH_ASSIGNED_CARD_ACCOUNTS_FAILED,
    FETCH_ASSIGNED_CARD_PAYMENT_INFO_REQUEST,
    FETCH_ASSIGNED_CARD_PAYMENT_INFO_SUCCESS,
    FETCH_ASSIGNED_CARD_PAYMENT_INFO_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_ASSIGNED_CARD_ACCOUNTS_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_ASSIGNED_CARD_ACCOUNTS_SUCCESS]: (state, { status, data }) => {
        state.status = status
        if (status !== 204) {
            state.assignedAccounts = data || []
        } else {
            state.assignedAccounts = data
        }
    },
    [FETCH_ASSIGNED_CARD_ACCOUNTS_FAILED]: (state, erorr) => {
        state.status = 'error'
    },
    [FETCH_ASSIGNED_CARD_PAYMENT_INFO_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_ASSIGNED_CARD_PAYMENT_INFO_SUCCESS]: (state, { status, data }) => {
        state.status = status
        if (status !== 204) {
            state.paymentInfo = data || []
        } else {
            state.paymentInfo = data
        }
    },
    [FETCH_ASSIGNED_CARD_PAYMENT_INFO_FAILED]: (state, error) => {
        state.status = 'error'
    }
}

export default mutations
